// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './MenuItem.module.css';

/**
 * Individual menu item
 * @param {object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {boolean} [props.isActive] - Whether this anchor is currently active
 * @param {boolean} [props.disabled] - Whether this anchor is currently disabled
 * @param {(e: React.MouseEvent<HTMLButtonElement>) => void} [props.onClick] - Click handler function
 * @param {React.ReactNode} [props.children] - Children elements
 * @returns {JSX.Element} MenuItem component
 */
function MenuItem({
  className = '', isActive = false, disabled = false, onClick = () => {}, children,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn([
        styles['menu-item'],
        isActive && styles['menu-item-active'],
        disabled && styles['menu-item-disabled'],
        className,
      ])}
      tabIndex={disabled ? -1 : 0}
    >
      <span className={styles['menu-item-text']}>{children}</span>
    </button>
  );
}

export default MenuItem;
